import { Component, OnInit, Input, Inject } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
export interface DialogData {
  tkuser: string;
}
declare var Keynua: any;

@Component({
  selector: "app-keynua-widget",
  templateUrl: "./keynua-widget.component.html",
  styleUrls: ["./keynua-widget.component.scss"],
})
export class KeynuaWidgetComponent implements OnInit {
  @Input() tkClient;

  tokenCli = null;
  constructor(
    public dialogRef: MatDialogRef<KeynuaWidgetComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    console.log(data);
    // this.tokenCli = data.tkuser;
  }

  ngOnInit(): void {
    // Keynua.run();
    //inicializa el widget
    Keynua.run({
      token: this.data.tkuser,
      uiCallback: (ev) => {
     //   console.log("35", ev);
      },
    });
  }
}
